import { Label, Textarea } from '@/components/Forms/styles';

type Props = {
  name: string;
  maxLength?: number;
  label: string;
};

const Web2CaseTextArea = ({ name, label, maxLength }: Props) => {
  return (
    <div>
      <Label htmlFor={name}>{label}</Label>
      <Textarea id={name} name={name} maxLength={maxLength} className="min-h-36" />
    </div>
  );
};

export default Web2CaseTextArea;
